import { ApplicationType } from '../../services/dtos'
import { AccessMethodType } from './application-creator-state.service'

// The connect page and the template-choice step both have to answer "does the
// outdated-template path apply to this sync pair?". They read it from different
// places -- live AccessService instances vs a cached response -- so the answer
// lives here as pure functions instead of a getter on either page. If they
// disagreed, the two would redirect to each other forever.

// AccessService satisfies this structurally, as do plain test stubs.
export interface AccessSnapshot {
  accessUsable: boolean
  hasLatestVersion: boolean
  managedByStackSet: boolean
}

interface StackSetsAccountSettings {
  stacksetsCapabilityEnabled: boolean
  stacksetsEnabled: boolean | null
}

// StackSets is an AWS-only access method. Azure must never take this path, even
// when the account-level setting says stacksets or a stale creator-state choice
// survives from an abandoned AWS session (persisted for 24h).
export function stackSetsModeActive(
  applicationType: ApplicationType | '',
  accessMethod: AccessMethodType,
  account: StackSetsAccountSettings
): boolean {
  if (applicationType !== ApplicationType.AWS) {
    return false
  }
  if (accessMethod !== null) {
    return accessMethod === 'stacksets'
  }
  return account.stacksetsCapabilityEnabled && account.stacksetsEnabled === true
}

// Both endpoints work and are managed the way the selected access method requires,
// but at least one is behind the latest access template. Anything else wrong (no
// access, invalid config, not yet StackSet-managed) keeps the existing hard block.
export function templatesOutOfDateOnly(
  source: AccessSnapshot | null,
  target: AccessSnapshot | null,
  stackSetsMode: boolean
): boolean {
  if (!source?.accessUsable || !target?.accessUsable) {
    return false
  }
  if (stackSetsMode && !(source.managedByStackSet && target.managedByStackSet)) {
    return false
  }
  return !source.hasLatestVersion || !target.hasLatestVersion
}
